import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import {
    validateFirstname,
    ContactTypes,
    validateLastname,
    validateContactEmail,
    validateMobileNumber,
} from '../../../Validation';
import some from 'lodash/some';
import { SectionProps } from '../../types';
import Panel from "@sharedComponents/Panel";
import InputText from "@sharedComponents/InputText";

const AgreementForm = (props: SectionProps) => {
    const {
        stepValues,
        setStepValues,
        onChangeValues,
        formErrors,
        setFormErrors,
    } = props
    const { t } = useTranslation()

    const onChangeFirstname = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const obj = {
            ...stepValues.contactInfo,
            agreement: {
                ...stepValues.contactInfo?.agreement,
                firstname: value,
            },
        }

        setStepValues({ ...stepValues, contactInfo: obj })
        onChangeValues && onChangeValues({ contactInfo: obj })

        const errors = validateFirstname(
            value,
            formErrors,
            ContactTypes.Agreement
        )
        setFormErrors(errors)
    }

    const onChangeLastname = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const obj = {
            ...stepValues.contactInfo,
            agreement: {
                ...stepValues.contactInfo?.agreement,
                lastname: value,
            },
        }

        setStepValues({ ...stepValues, contactInfo: obj })
        onChangeValues && onChangeValues({ contactInfo: obj })

        const errors = validateLastname(
            value,
            formErrors,
            ContactTypes.Agreement
        )
        setFormErrors(errors)
    }

    const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const obj = {
            ...stepValues.contactInfo,
            agreement: {
                ...stepValues.contactInfo?.agreement,
                email: value,
            },
        }

        setStepValues({ ...stepValues, contactInfo: obj })
        props.onChangeValues && props.onChangeValues({ contactInfo: obj })

        const errors = validateContactEmail(
            value,
            formErrors,
            ContactTypes.Agreement
        )
        setFormErrors(errors)
    }

    const onChangeMobile = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const obj = {
            ...stepValues.contactInfo,
            agreement: {
                ...stepValues.contactInfo?.agreement,
                mobileNumber: value,
            },
        }

        setStepValues({ ...stepValues, contactInfo: obj })
        props.onChangeValues && props.onChangeValues({ contactInfo: obj })

        const errors = validateMobileNumber(
            value,
            formErrors,
            ContactTypes.Agreement
        )
        setFormErrors(errors)
    }

    const onChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const obj = {
            ...stepValues.contactInfo,
            agreement: {
                ...stepValues.contactInfo?.agreement,
                phoneNumber: value,
            },
        }
        setStepValues({ ...stepValues, contactInfo: obj })
        props.onChangeValues && props.onChangeValues({ contactInfo: obj })
    }

    const uniqueErrors = (key: string) => {
        const errors = formErrors.find(err => err.key === key);
        const uniqueErr = errors ? [...new Set(errors.messages)] : [];

        return uniqueErr.length > 0 ? uniqueErr.join(', ') : '';
    }

    return (
        <div className='producer-panel-wrapper producer-form'>
            <Panel className="panel--crb">
                <h3>{t('companyRegistration.agreement')}</h3>
                <div className='producer-form__fields'>
                    <div className='producer-form__field'>
                        <InputText
                            id="crb-agr-firstname"
                            label={t('global.firstname')}
                            required={true}
                            hasError={
                                !!some(formErrors, [
                                    'key',
                                    `${ContactTypes.Agreement}Firstname`,
                                ])
                            }
                            value={
                                stepValues.contactInfo?.agreement?.firstname ||
                                ''
                            }
                            maxLength={50}
                            onChange={onChangeFirstname}
                            autoComplete="given-name"
                            errorText={uniqueErrors(`${ContactTypes.Agreement}Firstname`)}
                        />
                    </div>
                    <div className='producer-form__field'>
                        <InputText
                            id="crb-agr-lastname"
                            label={t('global.lastname')}
                            required={true}
                            hasError={
                                !!some(formErrors, [
                                    'key',
                                    `${ContactTypes.Agreement}Lastname`,
                                ])
                            }
                            value={
                                stepValues.contactInfo?.agreement?.lastname ||
                                ''
                            }
                            maxLength={50}
                            onChange={onChangeLastname}
                            autoComplete="family-name"
                            errorText={uniqueErrors(`${ContactTypes.Agreement}Lastname`)}
                        />
                    </div>
                    <div className='producer-form__field'>
                        <InputText
                            id="crb-agr-email"
                            label={t('global.email')}
                            required={true}
                            hasError={
                                !!some(formErrors, [
                                    'key',
                                    `${ContactTypes.Agreement}Email`,
                                ])
                            }
                            value={
                                stepValues.contactInfo?.agreement?.email || ''
                            }
                            onChange={onChangeEmail}
                            type="email"
                            autoComplete="email"
                            maxLength={250}
                            errorText={uniqueErrors(`${ContactTypes.Agreement}Email`)}
                        />
                    </div>
                    <div className='producer-form__field'>
                        <InputText
                            id="crb-agr-mobile"
                            label={t('global.mobileNumber')}
                            required={true}
                            hasError={
                                !!some(formErrors, [
                                    'key',
                                    `${ContactTypes.Agreement}MobileNumber`,
                                ])
                            }
                            value={
                                stepValues.contactInfo?.agreement
                                    ?.mobileNumber || ''
                            }
                            maxLength={30}
                            onChange={onChangeMobile}
                            autoComplete="tel"
                            errorText={uniqueErrors(`${ContactTypes.Agreement}MobileNumber`)}
                        />
                    </div>
                    <div className='producer-form__field'>
                        <InputText
                            id="crb-agr-phone"
                            label={t('global.phoneNumber')}
                            value={
                                stepValues.contactInfo?.agreement
                                    ?.phoneNumber || ''
                            }
                            maxLength={30}
                            onChange={onChangePhone}
                            autoComplete="tel"
                        />
                    </div>
                </div>
            </Panel>
        </div>
    )
}

export default AgreementForm